import { format, startOfDay, addMonths } from 'date-fns';

export const now = new Date();

export const currentMonth = startOfDay(
  new Date(now.getFullYear(), now.getMonth(), now.getDate()),
);

export const monthForward = startOfDay(addMonths(now, 1));

// export const monthForward = startOfDay(
//   new Date(
//     new Date(now.getFullYear(), now.getMonth() + 1, now.getDate()).setMonth(
//       now.getMonth() + 1,
//     ),
//   ),
// );

export const toISODate = (date) => {
  return format(date, 'yyyy-MM-dd');
};
